/*
 *
 * Package: `@dbh/hotel-description-theme`.
 *
 */const THEME_KEY_HOTEL_DESCRIPTION="hotelDescription";const modifyHotelDescriptionTheme=a=>{let{colors:{greyUltralight:b}}=a;return {[THEME_KEY_HOTEL_DESCRIPTION]:{wrapper:{padding:"sp7 0",borderTop:"1px solid "+b,borderBottom:"1px solid "+b},description:{collapsedRows:2},md:{wrapper:{borderTop:"none",borderBottom:"none"},description:{collapsedRows:9,collapsedRowsInReducedHeightMode:5}}}}};

export { THEME_KEY_HOTEL_DESCRIPTION, modifyHotelDescriptionTheme as default };
